/* QC — icon + text popups
 * Any block marked [data-qc-popup] opens a reusable modal with the content in its
 * <template class="icon-text-popup">. If the block sits inside a container marked
 * [data-qc-popup-carousel], the modal becomes a swipeable carousel of every popup
 * in that container, with navigation dots, opened at the clicked one.
 */
(function () {
  'use strict';

  var CSS = ''
    + '.icon-text--clickable:focus-visible{outline:2px solid currentColor;outline-offset:3px}'
    + '.qc-pop-overlay{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:20px;box-sizing:border-box}'
    + '.qc-pop-overlay.is-open{display:flex}'
    + '.qc-pop-card{position:relative;background:#fff;color:#111;max-width:460px;width:100%;border-radius:10px;padding:30px 26px 24px;box-shadow:0 24px 60px rgba(0,0,0,.28);box-sizing:border-box;max-height:calc(100vh - 40px);overflow:hidden;display:flex;flex-direction:column;font-family:inherit}'
    + '.qc-pop-close{position:absolute;top:12px;right:12px;width:34px;height:34px;border:0;background:transparent;font-size:26px;line-height:1;cursor:pointer;color:#111;border-radius:50%;z-index:2}'
    + '.qc-pop-close:hover{background:rgba(0,0,0,.06)}'
    + '.qc-pop-track{display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;-webkit-overflow-scrolling:touch}'
    + '.qc-pop-track::-webkit-scrollbar{display:none}'
    + '.qc-pop-slide{flex:0 0 100%;min-width:100%;scroll-snap-align:start;box-sizing:border-box;overflow-y:auto;padding-right:2px}'
    + '.qc-pop-slide .qc-pop__title{margin:0 20px 12px 0;font-size:21px;line-height:1.25;font-weight:700}'
    + '.qc-pop-slide .qc-pop__body{font-size:15px;line-height:1.6}'
    + '.qc-pop-slide .qc-pop__body p{margin:0 0 14px}'
    + '.qc-pop-slide .qc-pop__body :last-child{margin-bottom:0}'
    + '.qc-pop-slide a.qc-pop__link{display:inline-block;margin-top:16px;font-size:15px;font-weight:600;color:#111;text-decoration:underline;text-underline-offset:3px}'
    + '.qc-pop-dots{display:flex;justify-content:center;gap:8px;margin-top:18px;flex-wrap:wrap}'
    + '.qc-pop-dot{width:8px;height:8px;padding:0;border:0;border-radius:50%;background:rgba(0,0,0,.22);cursor:pointer;transition:background .2s,transform .2s}'
    + '.qc-pop-dot.is-active{background:#111;transform:scale(1.2)}';

  function injectCSS() {
    if (document.getElementById('qc-pop-style')) return;
    var s = document.createElement('style');
    s.id = 'qc-pop-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var overlay, card, track, dotsWrap, lastFocus;

  function build() {
    if (overlay) return;
    injectCSS();
    overlay = document.createElement('div');
    overlay.className = 'qc-pop-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    card = document.createElement('div');
    card.className = 'qc-pop-card';
    card.innerHTML = '<button type="button" class="qc-pop-close" aria-label="Close">×</button>'
      + '<div class="qc-pop-track"></div><div class="qc-pop-dots"></div>';
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    track = card.querySelector('.qc-pop-track');
    dotsWrap = card.querySelector('.qc-pop-dots');
    card.querySelector('.qc-pop-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    track.addEventListener('scroll', syncDots);
    window.addEventListener('resize', function () { if (overlay.classList.contains('is-open')) goTo(active, false); });
  }

  var active = 0;

  function slideEl(tpl) {
    var s = document.createElement('div');
    s.className = 'qc-pop-slide';
    s.appendChild(tpl.content.cloneNode(true));
    return s;
  }

  function goTo(i, smooth) {
    var n = track.children.length;
    active = Math.max(0, Math.min(i, n - 1));
    track.scrollTo({ left: active * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    updateDots();
  }

  function updateDots() {
    for (var k = 0; k < dotsWrap.children.length; k++) {
      dotsWrap.children[k].classList.toggle('is-active', k === active);
    }
  }

  function syncDots() {
    if (!track.clientWidth) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== active) { active = i; updateDots(); }
  }

  function render(templates, startIndex) {
    build();
    track.innerHTML = '';
    dotsWrap.innerHTML = '';
    templates.forEach(function (tpl, i) {
      track.appendChild(slideEl(tpl));
      if (templates.length > 1) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'qc-pop-dot';
        d.setAttribute('aria-label', 'Go to item ' + (i + 1));
        d.addEventListener('click', function () { goTo(i, true); });
        dotsWrap.appendChild(d);
      }
    });
    dotsWrap.style.display = templates.length > 1 ? 'flex' : 'none';
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    /* jump to the clicked item without animation, once laid out */
    active = startIndex || 0;
    requestAnimationFrame(function () { goTo(active, false); });
    card.querySelector('.qc-pop-close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function trigger(e) {
    if (e.target.closest && e.target.closest('.qc-pop-overlay')) return;
    var el = e.target.closest ? e.target.closest('[data-qc-popup]') : null;
    if (!el) return;
    var own = el.querySelector('template.icon-text-popup');
    if (!own) return;
    e.preventDefault();
    e.stopPropagation();
    var carousel = el.closest ? el.closest('[data-qc-popup-carousel]') : null;
    if (carousel) {
      var blocks = carousel.querySelectorAll('[data-qc-popup]');
      var templates = [], start = 0;
      for (var i = 0; i < blocks.length; i++) {
        var t = blocks[i].querySelector('template.icon-text-popup');
        if (!t) continue;
        if (blocks[i] === el) start = templates.length;
        templates.push(t);
      }
      render(templates, start);
    } else {
      render([own], 0);
    }
  }

  document.addEventListener('click', trigger, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target.closest ? e.target.closest('[data-qc-popup]') : null;
    if (el) trigger(e);
  }, true);
})();
